import { render, staticRenderFns } from "./ClientProfileOrderHistory.vue?vue&type=template&id=47fb418c&scoped=true"
import script from "./ClientProfileOrderHistory.vue?vue&type=script&lang=js"
export * from "./ClientProfileOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb418c",
  null
  
)

export default component.exports